import { useEffect, useRef } from 'react';
import { IChildrenProp } from 'types/components/components.interface';
import './InfoBoxItems.scss';

export interface IInfoBoxItemsProps extends IChildrenProp {
  rows?: number;
  columns?: number;
}

const InfoBoxItems = ({ children, rows, columns }: IInfoBoxItemsProps) => {
  const ref = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={ref}
      className='info-box-items'
      style={{
        gridTemplateRows: rows ? `repeat(${rows}, 45px)` : 'auto',
        maxWidth: columns ? `${columns * 350}px` : '1fr',
      }}>
      {children}
    </div>
  );
};

export default InfoBoxItems;
